import { __assign } from "tslib";
import { buildSchema } from 'graphql';
import { printSchemaWithDirectives } from './print-schema-with-directives';
function buildFixedSchema(schema, options) {
    return buildSchema(printSchemaWithDirectives(schema), __assign({ noLocation: true }, (options || {})));
}
export function fixSchemaAst(schema, options) {
    var schemaWithValidAst;
    if (!schema.astNode || !schema.extensionASTNodes) {
        schemaWithValidAst = buildFixedSchema(schema, options);
    }
    if (!schema.astNode) {
        schema.astNode = schemaWithValidAst.astNode;
    }
    if (!schema.extensionASTNodes) {
        schema.extensionASTNodes = schemaWithValidAst.extensionASTNodes;
    }
    return schema;
}
//# sourceMappingURL=fix-schema-ast.js.map